<div class="modal-header">
  <h5 class="modal-title">Chỉnh Sửa Nhà Xuất Bản</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <!-- Publisher Name Field with Tooltip -->
    <div class="form-group">
      <label for="publisherName" id="publisherName_display_as_box">
        Tên Nhà Xuất Bản
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập tên của nhà xuất bản."></i>
      </label>
      <input
        id="publisherName"
        name="name"
        class="form-control"
        type="text"
        placeholder="ví dụ: Nhà Xuất Bản Kim Đồng"
        [(ngModel)]="publisher.name"
      />
    </div>

    <!-- Address Field with Tooltip -->
    <div class="form-group">
      <label for="address" id="address_display_as_box">
        Địa Chỉ
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập địa chỉ của nhà xuất bản."></i>
      </label>
      <input
        id="address"
        name="address"
        class="form-control"
        type="text"
        placeholder="ví dụ: 123 Đường Chính, Thành Phố, Quốc Gia"
        [(ngModel)]="publisher.address"
      />
    </div>

    <!-- Email Field with Tooltip -->
    <div class="form-group">
      <label for="email" id="email_display_as_box">
        Email
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập địa chỉ email của nhà xuất bản."></i>
      </label>
      <input
        id="email"
        name="email"
        class="form-control"
        type="email"
        placeholder="ví dụ: contact@publisher.com"
        [(ngModel)]="publisher.email"
      />
    </div>

    <!-- Phone Field with Tooltip -->
    <div class="form-group">
      <label for="phone" id="phone_display_as_box">
        Điện Thoại
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập số điện thoại của nhà xuất bản."></i>
      </label>
      <input
        id="phone"
        name="phone"
        class="form-control"
        type="tel"
        placeholder="ví dụ: +1-234-567-8900"
        [(ngModel)]="publisher.phone"
      />
    </div>

    <!-- Country Field with Tooltip -->
    <div class="form-group">
      <label for="country" id="country_display_as_box">
        Quốc Gia
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Chọn quốc gia của nhà xuất bản."></i>
      </label>
      <select
        id="country"
        name="country"
        class="form-control"
        [(ngModel)]="publisher.country"
      >
        <option *ngFor="let country of countries" [ngValue]="country">{{ country }}</option>
      </select>
    </div>

    <!-- Website Field with Tooltip -->
    <div class="form-group">
      <label for="website" id="website_display_as_box">
        Website
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Mô tả:</b> Nhập URL của website nhà xuất bản."></i>
      </label>
      <input
        id="website"
        name="website"
        class="form-control"
        type="url"
        placeholder="ví dụ: https://www.publisher.com"
        [(ngModel)]="publisher.website"
      />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
  <button type="button" class="btn btn-outline-primary" (click)="savePublisher()">Save</button>
</div>
